module.exports = __webpack_public_path__ + "img/00016.2e9a45cc.webp";